export default __webpack_public_path__ + "static/media/perks-program-1x.22829da5.png";